<template>
  <ul>
    <li class="has-text-weight-bold">{{ column.tabname }}</li>

    <li v-show="hasGeneralText">
      <span
        class="icon pointer"
        @click="$emit('showGeneralText')">

        <i class="fas fa-caret-right"></i>
      </span>

      <span
        class="pointer"
        @click="$emit('showGeneralText')">

      Algemeen
    </span>
    </li>

    <page-tree-item
      v-for="value in values"
      :key="value.id"
      :parents="[]"
      :value="value"
      :depth="0"
      :show="false"
      :last="false">
    </page-tree-item>
  </ul>
</template>

<script>
import { mapGetters } from 'vuex'
import PageTreeItem from '@/components/pages/PageTreeItem'

export default {
  name: 'PageTree',
  components: {
    PageTreeItem
  },
  computed: {
    ...mapGetters({
      auth: 'account/auth',
      page: 'pages/page'
    }),
    column () {
      return this.page.columnProperties.find(x => x.id === this.page.columns[0])
    },
    values () {
      return (this.page) ? this.page.tree : []
    },
    hasGeneralText () {
      return this.page && this.page.page_texts[0]
    }
  }
}
</script>

<style scoped>
  .pointer {
    cursor: pointer;
  }
</style>
